import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, BarChart2, Bell, HelpCircle } from 'lucide-react';
import { useTokens } from '../context/ThemeContext';

export const SIDEBAR_WIDTH = '220px';

const NAV_ITEMS = [
  { path: '/transactions', label: 'Transactions', Icon: LayoutDashboard },
  { path: '/analytics',    label: 'Analytics',    Icon: BarChart2 },
  { path: '/budgets',      label: 'Budgets',      Icon: Bell },
];

function LeftSidebar({ onStartTour }) {
  const t = useTokens();
  const location = useLocation();

  const tourLabelForPath = (path) => {
    if (path.includes('transactions')) return 'transactions';
    if (path.includes('analytics')) return 'analytics';
    if (path.includes('budgets')) return 'budgets';
    return 'transactions';
  };

  return (
    <aside style={{ position: 'fixed', top: '56px', left: 0, bottom: 0, width: SIDEBAR_WIDTH, backgroundColor: t.surface, borderRight: `1px solid ${t.border}`, display: 'flex', flexDirection: 'column', padding: '16px 12px', zIndex: 10 }}>
      <nav style={{ display: 'flex', flexDirection: 'column', gap: '4px', flex: 1 }}>
        {NAV_ITEMS.map(({ path, label, Icon }) => (
          <NavLink
            key={path}
            to={path}
            style={({ isActive }) => ({
              display: 'flex', alignItems: 'center', gap: '10px',
              padding: '9px 12px', borderRadius: '8px',
              fontSize: '14px', fontWeight: '500',
              textDecoration: 'none',
              transition: 'all 0.15s',
              backgroundColor: isActive ? t.navActive : 'transparent',
              color: isActive ? t.navActiveText : t.textSecondary,
            })}
          >
            {({ isActive }) => (
              <>
                <Icon size={16} style={{ color: isActive ? t.navActiveIcon : t.textMuted, flexShrink: 0 }} />
                <span>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      {/* Help / Tour button */}
      <div style={{ borderTop: `1px solid ${t.borderLight}`, paddingTop: '12px' }}>
        <button
          onClick={() => onStartTour && onStartTour(tourLabelForPath(location.pathname))}
          style={{
            display: 'flex', alignItems: 'center', gap: '10px',
            width: '100%', padding: '9px 12px', borderRadius: '8px',
            border: 'none', backgroundColor: 'transparent',
            color: t.textSecondary, fontSize: '14px', fontWeight: '500',
            cursor: 'pointer', transition: 'background-color 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.backgroundColor = t.chipBg}
          onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
        >
          <HelpCircle size={16} style={{ color: t.textMuted, flexShrink: 0 }} />
          <span>Help &amp; tour</span>
        </button>
      </div>
    </aside>
  );
}

export default LeftSidebar;
